<template>
    <div
        class="coming-soon-root d-flex align-items-center justify-content-center"
    >
        <h6 class="mb-0 text-center white">
            {{ $t('tests.tests.comingSoon') }}
        </h6>
    </div>
</template>

<script>
export default {
    name: 'ComingSoon',
};
</script>

<style scoped>
.coming-soon-root {
    position: absolute;
    right: -54px;
    top: 26px;

    height: 40px;
    width: 200px;
    background-color: var(--primary);
    transform: rotateZ(45deg);
}
</style>
